import { render, staticRenderFns } from "./HabeasDataForm.vue?vue&type=template&id=1be80c0a&scoped=true"
import script from "./HabeasDataForm.vue?vue&type=script&lang=js"
export * from "./HabeasDataForm.vue?vue&type=script&lang=js"
import style0 from "./HabeasDataForm.vue?vue&type=style&index=0&id=1be80c0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be80c0a",
  null
  
)

export default component.exports